import React, { useEffect, useState } from 'react'
import "./newProduct.css";
import { useSelector, useDispatch } from 'react-redux';
import { clearErrors } from '../../actions/productAction';
import { useAlert } from 'react-alert';
import { Button } from '@material-ui/core';
import MetaData from '../layout/MetaData';
import MailOutlineIcon from "@material-ui/icons/MailOutline"
import Sidebar from './Sidebar';
import { useNavigate, useParams } from 'react-router-dom';
import { UPDATE_USER_RESET } from '../../actions/constants/userConstants';
import { getUserDetails, updateUser } from '../../actions/userAction';
import PersonIcon from "@material-ui/icons/Person";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import Loader from '../layout/Loader/Loader';




const UpdateUser = () => {

    const dispatch = useDispatch();
    const alert = useAlert();

    const { loading, error, user } = useSelector((state) => state.userDetails)

    const { loading: updateLoading, error: updateError, isUpdated } = useSelector((state) => state.profile)
    
    const [email, setEmail] = useState("");
    const [name, setName] = useState("")
    const [role, setRole] = useState("")

    const navigate = useNavigate();

    const {id} = useParams();

    const userId = id;

    useEffect(() => {

        if (user && user._id !== userId) {
            dispatch(getUserDetails(userId))
        }
        else {
            setName(user.name);
            setEmail(user.email);
            setRole(user.role);
        }
        if (error) {
            alert.error(error);
            dispatch(clearErrors());

        }
        if (updateError) {
            alert.error(updateError);
            dispatch(clearErrors());

        }

        if (isUpdated) {
            alert.success("User Updated  Successfullly");
            navigate("/admin/users");
            dispatch({
                type: UPDATE_USER_RESET,
            })
        }


    }, [dispatch, alert, error, navigate,isUpdated,updateError,user,userId])


    const updateUserSubmitHandler = (e) => {
        e.preventDefault();
        const myForm = new FormData();
        myForm.set("name", name);
        myForm.set("email", email);
        myForm.set("role", role);
        dispatch(updateUser(userId,myForm))
    }
 

    return (
        <>
            <MetaData title="Update User" />
            <div className="dashboard">
                <Sidebar />
                <div className="newProductContainer">
                  {loading ? <Loader /> :   <form action="" className='createProductForm'  onSubmit={updateUserSubmitHandler}>
                        <h1>Update User</h1>
                        <div>
                            <PersonIcon />
                            <input type="text" placeholder='Name' required value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div>
                            <MailOutlineIcon/>
                            <input type="email"  placeholder='Email' value={email} required onChange={(e) => setEmail(e.target.value)} />
                        </div>

                        <div>
                            <VerifiedUserIcon />
                            {/* <textarea  placeholder='Product Desription' value={description} rows="1" cols="30" onChange={(e)=>setDescription(e.target.value)} > */}

                            {/* </textarea> */}

                            <select value={role} onChange={(e) => setRole(e.target.value)} id="">
                                <option value="">
                                    Choose Role
                                </option>
                                <option value="admin">
                                    Admin
                                </option>
                                <option value="user">
                                    User
                                </option>
                            </select>
                        </div>

                        <Button id="createProductBtn" type='submit' disabled={updateLoading ? true : false || role===""?true:false}>
                            Update
                        </Button>
                    </form>}
                </div>
            </div>
        </>
    )
}


export default UpdateUser
